import { render, staticRenderFns } from "./ApprovedMission.vue?vue&type=template&id=07132c3b&"
import script from "./ApprovedMission.vue?vue&type=script&lang=js&"
export * from "./ApprovedMission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports